import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function MessagedBy(props: any) {
  const { message } = props;

  const configuration = useSelector((state: any) => state?.configuration);
  const design = useSelector((state: any) => state?.design);
  const environment = useSelector((state: any) => state?.environment);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentTime, setCurrentTime] = useState(new Date().toISOString());


  useEffect(() => {

    const loadLocale = async (locale: string) => {

      try {
        await import(`moment/locale/${locale}`);
        moment.locale(locale);
        setCurrentTime(new Date().toISOString());

      } catch (error) {
        // console.error(`Failed to load locale ${locale}:`, error);
        moment.locale('en');
        setCurrentTime(new Date().toISOString());

      }
    };

    loadLocale(configuration?.generalSettings?.language)
      .catch(err => console.log(err));

    return () => {
      moment.locale('en');
    }

  }, [configuration?.generalSettings?.language]);

  /**
   * Author: Divyansh
   * Date: 24 Feb 2023
   * Summary: Rerender component in order to keep updating the time
   */
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toISOString());
    }, 10000); // Update every 10 seconds

    return () => clearInterval(interval);
  }, []);

  const getUserTime = (time: string): string => {

    const dateTimeString = new Date(time).toISOString();

    try {
      if (!moment(dateTimeString).isBefore(moment().subtract(30, 'seconds'))) {
        return ' ' + moment(dateTimeString).fromNow();
      } else if (moment(dateTimeString).isBefore(moment().subtract(1, 'days'))) {
        return ' . ' + moment(dateTimeString).format('lll');
      }

      return ' . ' + moment(dateTimeString).format('LT');
    } catch (error) {
      return '';
    }

  }


  return (message && message.createdAt && getUserTime(message?.createdAt) && configuration?.generalSettings &&
    <>
      {message.position !== 'right' &&
        <p id='ele-275' className="messaged-by p-2  text-secondaryText text-xs" style={{
          ...(design?.avatarPlacement !== 'top' && { marginLeft: '54px' }),
        }}>
          {message.messageBy === 'agent' ? `${environment.agentName}` : `${!!configuration?.chatMenu?.botMessageSubScript ? `${configuration?.chatMenu?.botMessageSubScript}` : ''}`}{getUserTime(message?.createdAt)} </p>
      }
    </>
  )
}
